import audioFormat from "astrid-distribution/src/constants/audioFormats";
import getExportPipeline from "astrid-firestore/src/api/exports/utils/getExportPipeline";

import createExportData from "./createExportData";

function getExportName(data) {
	return `${data.audioFormat}${data.audioFormat === audioFormat.MP3 ? ` (${data.bitrate})` : ""} | ${
		data.splitAudio
	} | ${data.rename}${data.zip ? " | zipped" : ""}${data.includeCover ? " | cover included" : ""}`;
}

export default function createExport(firebase, artifact, article, data) {
	const { isbn, ...rest } = data;

	const exportDoc = createExportData(firebase, {
		...rest,
		artifact,
		article: article?.isbn ? article : { isbn },
		name: getExportName(data),
		pipeline: getExportPipeline({ data }),
	});

	return exportDoc.ref.set(exportDoc);
}
